var _style, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgCSharpLogo(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 96 96",
    style: {
      enableBackground: "new 0 0 96 96"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\n\t.st0{fill:#68217A;}\n\t.st1{fill:#953DAC;}\n\t.st2{fill:#FFFFFF;}\n\t.st3{fill:#822C98;}\n")), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "surface48709323"
  }, /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M45.8,6.6c1.4-0.8,3-0.8,4.4,0c6.7,3.8,26.9,15.1,33.6,18.9c1.4,0.8,2.2,2.2,2.2,3.7c0,7.5,0,30.2,0,37.7 c0,1.5-0.8,2.9-2.2,3.7c-6.7,3.8-26.9,15.1-33.6,18.9c-1.4,0.8-3,0.8-4.4,0c-6.7-3.8-26.9-15.1-33.6-18.9c-1.4-0.8-2.2-2.2-2.2-3.7 c0-7.5,0-30.2,0-37.7c0-1.5,0.8-2.9,2.2-3.7C18.9,21.7,39.1,10.3,45.8,6.6z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M10.6,68.8c-0.5-0.7-0.6-1.4-0.6-2.3c0-7.5,0-30,0-37.5c0-1.5,0.8-2.9,2.2-3.7c6.7-3.7,26.8-15,33.5-18.8 c1.4-0.8,3.2-0.7,4.5,0c6.7,3.7,26.7,14.9,33.4,18.7c0.5,0.3,1,0.7,1.3,1.2L10.6,68.8z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M48,20c-15.5,0-28,12.5-28,28s12.5,28,28,28s28-12.5,28-28S63.5,20,48,20z M48,62c-7.7,0-14-6.3-14-14 s6.3-14,14-14s14,6.3,14,14S55.7,62,48,62z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st3",
    d: "M85,26.4c1,1,1,2.4,1,3.6c0,7.6-0.1,29.2,0,36.8c0,0.8-0.3,1.6-0.6,2.3L47.2,48L85,26.4z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M68,40h2v16h-2V40z M74,40h2v16h-2V40z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M64,50h16v2H64V50z M64,44h16v2H64V44z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCSharpLogo);
export default __webpack_public_path__ + "static/media/c-sharp-logo.194e7fc7d99d664ce33274fa6014340c.svg";
export { ForwardRef as ReactComponent };